import { useTranslation } from "react-i18next";

const WHY_ICONS = [
  "ri-folders-line",
  "ri-lightbulb-line",
  "ri-refresh-line",
  "ri-eye-line",
  "ri-global-line",
];

export default function WhyComparison() {
  const { t } = useTranslation();
  const whyItems = t("why.items", { returnObjects: true }) as { title: string; desc: string }[];
  const headers = t("comparison.headers", { returnObjects: true }) as string[];
  const rows = t("comparison.rows", { returnObjects: true }) as string[][];

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("why.title")}
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {whyItems.map((item, i) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${WHY_ICONS[i] ?? "ri-check-line"} text-lg`}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="border-b border-background-200 px-6 py-5 md:px-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {t("comparison.title")}
            </h3>
            <p className="mt-1 text-sm text-foreground-700">{t("comparison.subtitle")}</p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="bg-background-100">
                  {headers.map((h) => (
                    <th key={h} className="whitespace-nowrap px-6 py-3 font-semibold text-foreground-900">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={row[0]} className={i % 2 === 0 ? "bg-background-50" : "bg-background-100/60"}>
                    {row.map((cell, j) => (
                      <td
                        key={`${row[0]}-${j}`}
                        className={`px-6 py-3 ${
                          j === 0 ? "font-medium text-foreground-950" : "text-foreground-700"
                        }`}
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}